<template>
    <section class="section">
        <div class="hero">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1">EDAR Status Monitor</h1>
            </div>
        </div>
        <br>
        <div class="container">
            <div class="tile is-ancestor" style="flex-wrap: wrap; justify-content: center;">
                <div v-if="edars.length" class="tile is-parent" style="justify-content: center;">
                    <router-link class="tile is-child card staff-card"
                                 :to="{name: 'edar_overview'}"
                    >
                        <div class="card-header">
                            <h1 class="card-header-title title">EDAR Status</h1>
                        </div>
                        <div class="card-body" style="padding:1em;">
                            <div class="image">
                            <img :src="Edar_Image" alt="Image of an Edar" />
                            </div>
                            <p>Click here for EDAR Status Information.</p>
                        </div>
                    </router-link>
                </div>
                <div v-if="deployments.length" class="tile is-parent" style="justify-content: center;">
                    <router-link class="tile is-child card staff-card" :to="{name: 'deployment_overview'}">
                        <div class="card-header">
                            <h1 class="card-header-title title">Deployment Statistics</h1>
                        </div>
                        <div class="card-body" style="padding:1em;">
                            <div class="image">
                                <img src="https://images.pexels.com/photos/2348359/pexels-photo-2348359.jpeg?auto=compress&cs=tinysrgb&dpr=3&w=75"
                                     alt="Image of trucks"
                                />
<!--                                <img :src="Edar_Image"-->
                                <svg viewBox="0 0 400 250" xmlns="http://www.w3.org/2000/svg" style="position: absolute; top: 0; left: 0;"
                                >
                                    <g stroke="blue" stroke-width="3">
                                        <line x1="0" y1="0" x2="100" y2="100" />
                                        <line x1="100" y1="100" x2="200" y2="50" />
                                        <line x1="200" y1="50" x2="350" y2="150" />
                                        <line x1="350" y1="150" x2="400" y2="250" />
                                    </g>
                                    <g stroke="red" stroke-width="3">
                                        <line x1="0" y1="250" x2="50" y2="100" />
                                        <line x1="50" y1="100" x2="100" y2="50" />
                                        <line x1="100" y1="50" x2="150" y2="200" />
                                        <line x1="150" y1="200" x2="250" y2="150" />
                                        <line x1="250" y1="150" x2="300" y2="100" />
                                        <line x1="300" y1="100" x2="400" y2="0" />
                                    </g>
                                </svg>
                            </div>
                            <p>Click here for Information about Current Deployments.</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <span style="font-size: xx-small; position: absolute; top: 0; left: 0;">I was always here.</span>
    </section>
</template>

<script>
    import {mapState} from "vuex";
    import Edar_Image from "heat-shared/static/Edar Image.webp"

    export default {
        name: "Staff",
        computed: {
            ...mapState('edar', [
                'edars',
            ]),
            ...mapState('deployment', [
                'deployments',
            ]),
            Edar_Image: () => Edar_Image,
        },
    }
</script>

<style scoped>
    .staff-card {
        max-width: 30rem;
    }
</style>